module.exports = __webpack_public_path__ + "img/img_level_15.d163e491.png";